import { gql } from 'graphql-request';

export const RECEIPT_ONE = gql`
  query receipt_one($reference_id: String!) {
    orders(where: { reference_id: {_eq: $reference_id }}) {
      items
      reference_id
      subtotal
      tax
      tip
      status

      transaction_at
      transaction_time
      id
      event {
        name
        digital_surcharge_label
      }
      tokens_redeemed
      discount
      total_promo_discount
      location {
        name
      }
      digital_surcharge
    }
  }
`;

export const RECEIPT_ONE_TICKETING = gql`
  query receipt_one($reference_id: String!) {
    orders_ticketing(where: { reference_id: {_eq: $reference_id }}) {
      items
      reference_id
      subtotal
      tax
      tip
      status

      transaction_at
      transaction_time
      id
      event {
        name
        digital_surcharge_label
      }
      tokens_redeemed
      discount
      total_promo_discount
      location {
        name
      }
      digital_surcharge
    }
  }
`;
